import { TenantMetadata } from "../../domain/TenantSlice/TenantMetadata";
import { NaturimalImageHashes } from "./NaturimalImageHashes";
import metadataJson from "./TenantMetadata.json";

export const NaturimalMetadata = {
  ...metadataJson,
  ImageHashes: NaturimalImageHashes,
} as TenantMetadata;